import type { AxiosError } from "axios";

const MAX_RETRIES_DEFAULT = 3;
const MAX_RETRIES_NOT_FOUND_OR_FORBIDDEN = 10;
const RETRY_DELAY_MS = 1000;

export const defaultRetry = (
  failureCount: number,
  error: AxiosError
): boolean => {
  if (error.response?.status === 404 || error.response?.status === 403) {
    return failureCount < MAX_RETRIES_NOT_FOUND_OR_FORBIDDEN;
  }
  return failureCount < MAX_RETRIES_DEFAULT;
};

export const defaultRetryDelay = () => RETRY_DELAY_MS;

export const retryQueryConfig = {
  retry: defaultRetry,
  retryDelay: defaultRetryDelay,
};
